import React, { useEffect, useState } from "react";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classnames from "classnames";
import CategoryWiseReport from "../component/CategoryWiseReport";
import ItemWiseReport from "../component/ItemWiseReport";
import ItemPercentReport from "../component/ItemPercentReport";
import CategoryServices from "../../../services/OrderingServices/CategoryService";

const SalesReportWise = () => {
  const [activeTab, setActiveTab] = useState("1");
  const [categoryData, setCategoryData] = useState([]);

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  // Fetch categories
  const fetchCategoryData = async () => {
    try {
      const response = await CategoryServices.maincategory();
      setCategoryData(response?.items || []);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };
  useEffect(() => {
    fetchCategoryData();
  }, []);
  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Stock Summary List" pageTitle="Stock Summary" />
      </div>

      <div>
        {/* Navigation */}
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "1" })}
              onClick={() => toggle("1")}
              style={{ cursor: "pointer" }}
            >
              Category Wise
            </NavLink>
          </NavItem>

          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "2" })}
              onClick={() => toggle("2")}
              style={{ cursor: "pointer" }}
            >
              Item Wise
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "3" })}
              onClick={() => toggle("3")}
              style={{ cursor: "pointer" }}
            >
              Item Sales Percentage
            </NavLink>
          </NavItem>
        </Nav>

        {/* Tab Content */}
        <TabContent activeTab={activeTab} className="p-3 border border-top-0">
          <TabPane tabId="1">
            <CategoryWiseReport
              categoryData={categoryData}
              setCategoryData={setCategoryData}
            />
          </TabPane>

          <TabPane tabId="2">
            <ItemWiseReport
              categoryData={categoryData}
              setCategoryData={setCategoryData}
              fetchCategoryData={fetchCategoryData}
            />
          </TabPane>
          <TabPane tabId="3">
            <ItemPercentReport
              categoryData={categoryData}
              setCategoryData={setCategoryData}
              fetchCategoryData={fetchCategoryData}
            />
          </TabPane>
        </TabContent>
      </div>
    </div>
  );
};

export default SalesReportWise;
